<template>
    <div v-if="user">
        <va-page-header>

            <div slot="title">
                <va-button class="back_button" @click.native="$router.go(-1)" type="default" size="lg">
                    <va-icon type="chevron-left"></va-icon>
                </va-button>
                {{_('Language Data')}}
            </div>

        </va-page-header>

        <va-form type="vertical" ref="form">
            <va-row :gutter="12" style="margin-bottom: 20px">
                <va-column :lg="6" :md="6" :sm="12" :xs="12">

                    <span class="field_label">{{ _('English') }}</span>
                    <va-textarea v-model="english" style="width: 100%" showClean name="name"></va-textarea>

                </va-column>

            </va-row>

            <va-row :gutter="12" style="margin-bottom: 20px">

                <va-column :lg="6" :md="6" :sm="12" :xs="12">

                    <span class="field_label">{{ _('Pashto') }}</span>
                    <va-textarea v-model="pashto" dir="rtl" style="width: 100%" showClean name="name"></va-textarea>

                </va-column>
            </va-row>
            <va-row :gutter="12" style="margin-bottom: 20px">

                <va-column :lg="6" :md="6" :sm="12" :xs="12">

                    <span class="field_label">{{ _('Dari') }}</span>
                    <va-textarea v-model="dari" dir="rtl" style="width: 100%" showClean name="name">
                    </va-textarea>

                </va-column>
            </va-row>

            <va-row :gutter="12">
                <va-column :lg="12" :md="12" :sm="12">

                    <va-button v-if="!viewedWord" type="primary" @click.native="createData" style="margin-right:10px">{{
                        _('Create') }}
                    </va-button>
                    <va-button v-else type="primary" @click.native="saveChanges" style="margin-right:10px">
                        {{ _('Save Changes') }}
                    </va-button>
                </va-column>
            </va-row>
        </va-form>
    </div>

</template>

<script>
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import Activities from './Activities'


    export default {
        components: {
            Activities
        },


        data() {
            return {
                english: '',
                pashto: '',
                dari: '',
                viewedWord: null,
            };
        },

        computed: {
            ...mapGetters(["user"]),


        },

        methods: {

            async createData() {
                this.$store.commit('setLoading', true)
                let q = new Parse.Query('LanguageData')
                var mainQuery = Parse.Query.or(new Parse.Query('LanguageData').equalTo('english', this.english), new Parse.Query('LanguageData').equalTo('pashto', this.pashto), new Parse.Query('LanguageData').equalTo('dari', this.dari));
                let result = await mainQuery.first()
                if (!result) {
                    let DeptClass = Parse.Object.extend('LanguageData')
                    let newDept = new DeptClass()
                    newDept.save({
                        english: this.english.trim(),
                        pashto: this.pashto.trim(),
                        dari: this.dari.trim(),
                        createdBy: this.user
                    }).then(async res => {
                        this.$store.commit('setLoading', false)
                        this.$notify({
                            group: 'foo',
                            text: this._('Lagnauge data was created'),
                            duration: 4000,
                            position: 'top left',
                            type: 'success'
                        });
                        setLanguageData()
                        // this.$router.go(-1)

                    }).catch(e => {
                        this.$store.commit('setLoading', false)
                        this.$notify({
                            group: 'foo',
                            text: this._('An error accured while creating language data'),
                            duration: 4000,
                            position: 'top left',
                            type: 'error'
                        });

                    })

                } else {
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        text: this._('Language Data already exists'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                }
            },

            async saveChanges() {
                this.viewedWord.set('english', this.english.trim())
                this.viewedWord.set('pashto', this.pashto.trim())
                this.viewedWord.set('dari', this.dari.trim())
                await this.viewedWord.save()
                    .then(async updated => {
                        this.$notify({
                            group: 'foo',
                            text: this._('Word was updated'),
                            duration: 4000,
                            position: 'top left',
                            type: 'success'
                        });
                        setLanguageData()
                    }).catch(e => {
                        this.$notify({
                            group: 'foo',
                            text: this._('An error accured while updating word'),
                            duration: 4000,
                            position: 'top left',
                            type: 'error'
                        });
                    })
            },

        },

        async mounted() {
            this.$store.commit("setLoading", true);
            if (this.$route.params.id !== 'new') {
                this.viewedWord = await this.g_fetchObject(this.$route.params.id, 'LanguageData')
                this.english = this.viewedWord.get('english')
                this.pashto = this.viewedWord.get('pashto')
                this.dari = this.viewedWord.get('dari')
            }
            this.$store.commit("setLoading", false);
        }
    };
</script>

<style>
    .members_list .va-form-group {
        margin-top: -5px;
        margin-bottom: -5px
    }
</style>